import { BaseEntity } from "yt-ng-framework";

export class Language extends BaseEntity{
    constructor(){
        super();
    }
    Name: string;

    Deserialize(input: any){
        this.ID=input.ID;
        this.Name=input.Name;
        return this;
    }

    Serialize(input: Language){
        return input;
    }
}